import { render, staticRenderFns } from "./ExamineAvatar.vue?vue&type=template&id=5643ef2e&scoped=true&"
import script from "./ExamineAvatar.vue?vue&type=script&lang=js&"
export * from "./ExamineAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ExamineAvatar.vue?vue&type=style&index=0&id=5643ef2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5643ef2e",
  null
  
)

export default component.exports